export const init = async (sonikit, patch, audioPlayer) => {
  await MusicKit.configure({
    developerToken: sonikit.apple_token,
    app: {
      name: 'Sonikit',
      icon: 'https://www.sonikit.com/sonikit-logo.jpg',
      build: '1'
    }
  })


  let playerStarted = false;
  const appleMusicPlayer = MusicKit.getInstance();
  
  await appleMusicPlayer.setQueue({
    [audioPlayer.service.media_type]: audioPlayer.service.media_id,
    position: 0
  })

  
  
  const previewArtworkURL = appleMusicPlayer.queue.nextPlayableItem.artworkURL.replace("{w}", "800").replace("{h}", "800");
  const item = appleMusicPlayer.queue.nextPlayableItem;

  const track = {
    id: item.id,
    artist: item.artistName,
    title: item.title,
    image_url: previewArtworkURL
  }
  audioPlayer.updateTrack(track);

  let apple_dialog_style = document.createElement("style");
  apple_dialog_style.textContent = `
    #musickit-dialog-scrim,
    #musickit-dialog {
      display: none !important;
    }
  `
  document.body.appendChild(apple_dialog_style);

  // Log events when authorization state changes
  appleMusicPlayer.addEventListener('authorizationStatusDidChange', function(event) {
    //console.log('Auth Changed To:' + appleMusicPlayer.isAuthorized);
    clearSessions()
    sonikit.emit('playerError', { message: 'Account not authorized. Please sign in again.' });
  });
  appleMusicPlayer.addEventListener('mediaPlaybackError', function(event) {
    return false;
    ////IMPORTANT///////
    event.preventDefualt();////IMPORTANT!!!! This prevents playback error alerts between playback seeking
    ////IMPORTANT///////
    console.log('Playback error')
    console.log(event);
  });
  appleMusicPlayer.addEventListener('eligibleForSubscribeView', function(event) {
    // console.log('Subscribe eligibility');
    // console.log(event);
  });
  appleMusicPlayer.addEventListener('mediaCanPlay', function(event) {
    //console.log(event);
  });

  // Watch events when playback state changes
  appleMusicPlayer.addEventListener('playbackStateDidChange', function(event) {
    let appleState;
    
    if (appleMusicPlayer.isPlaying) {
      appleState = 'playing';
      // appleMusicPlayer.capabilities.canSeek this deterimines if the player can seek
      if (!playerStarted) {
        playerStarted = true;
      }
    } else if (event.state === 10) {
      appleState = 'ended';
    } else {
      appleState = 'paused';
    }
      
    audioPlayer.setState(appleState);

    const item = appleMusicPlayer.nowPlayingItem;
    if (item) {
      const track = {
        id: item.id,
        artist: item.artistName,
        title: item.title,
        image_url: item.artworkURL.replace("{w}", "800").replace("{h}", "800")
      }
      audioPlayer.updateTrack(track);
    }
  });

  // Watch events when tracks change
  // DOES NOT FIRE WHEN changeToMediaAtIndex is called
  appleMusicPlayer.addEventListener('mediaItemDidChange', function(event) {
    const item = event.item;

    const track = {
      id: item.id,
      artist: item.artistName,
      title: item.title,
      image_url: item.artworkURL
    }
    audioPlayer.updateTrack(track);

    // Restart stream timer with new track
    audioPlayer.startTimer();
  });
  appleMusicPlayer.addEventListener('queuePositionDidChange', event => {
    // Track can change without triggering 'mediaItemDidChange'
    if (!appleMusicPlayer.nowPlayingItem) {
      return
    }
    
    const queued_check_1 = appleMusicPlayer.nowPlayingItem.id;
    setTimeout(() => {
      appleMusicPlayer.nowPlayingItem

      const queued_check_2 = appleMusicPlayer.nowPlayingItem.id;
      if (queued_check_1 !== queued_check_2) {
        const item = appleMusicPlayer.nowPlayingItem;

        const track = {
          id: item.id,
          artist: item.artistName,
          title: item.title,
          image_url: item.artworkURL.replace("{w}", "800").replace("{h}", "800")
        }
        audioPlayer.updateTrack(track);

        // Restart stream timer with new track
        audioPlayer.startTimer();
      }
    }, 1000);
  });

  // Detect playback error
  window.addEventListener("unhandledrejection", function(err, promise) { 
    if (err.reason.code === 11) {
      console.log('there was an error');
      console.log(err);
    }
  });

  return appleMusicPlayer;
}

export const removeDialogs = () => {
  sonikit.emit('playerReady', { service: 'apple-music' });

  // Apple music dialog
  const mk_dialog_style = document.querySelector('#musickit-dialog-style');
  const mk_dialog_scrim = document.querySelector('#musickit-dialog-scrim');
  const mk_dialog = document.querySelector('#musickit-dialog-scrim');

  if (mk_dialog_style) {
    mk_dialog_style.remove()
  }
  if (mk_dialog_scrim) {
    mk_dialog_scrim.remove()
  }
  if (mk_dialog) {
    mk_dialog.remove()
  }
}